// sharedFunctions.js
// TK 06/01/2022

/*******************************************************************************
 * @func openInNewTab
 * Opens a link in a new browser tab.
 *
 * @param link (string): link to open in new tag
 * @return None
 *
 * @notes None
 *
 ******************************************************************************/
export const openInNewTab = (link) => {
  var win = window.open(link, "_blank");
  win.focus();
};

/*******************************************************************************
 * @func isUserPublic
 * Whether a user has opted into a public profile. Mirrors the iOS app's
 * ProfileVisibility parsing (UserProfileModel.swift): the profileVisibility
 * field ("public"/"private"), with the legacy leaderboardOptIn flag as the
 * fallback for accounts that predate it. Default is private.
 *
 * @param user (object): The Users doc data
 * @return Boolean: True when the profile is public
 *
 * @notes None
 *
 ******************************************************************************/
export const isUserPublic = (user) => {
  if (!user) return false;
  if (user.profileVisibility === "public") return true;
  if (user.profileVisibility === "private") return false;
  return user.leaderboardOptIn === true;
};

/*******************************************************************************
 * @func plantHasSpriteArt
 * Checks that a plant + species pair has everything needed to draw a complete
 * sprite (pot, face, and stage artwork). Plants without full art are not
 * shown publicly on the website.
 *
 * @param plant (object): Plant doc data
 * @param species (object): Species doc data
 * @return Boolean: True when the sprite can be fully rendered
 *
 * @notes None
 *
 ******************************************************************************/
export const plantHasSpriteArt = (plant, species) => {
  const stage = species?.stages?.[plant?.stage || 0];
  return Boolean(
    stage?.plantBody?.imageName &&
      plant?.sprite?.pot?.imageName &&
      plant?.sprite?.eyes?.imageName &&
      plant?.sprite?.mouth?.imageName
  );
};
